var isScrolling = false;

export function initCarousel() {
	(function ($) {

		'use strict';

		$('.carousel-item').last().addClass('is-last');
		$('.carousel-slide-link--4').eq(1).hide();
		$('.carousel-slide-link--4').eq(2).hide();
		$('.carousel-slide-link--7').eq(1).hide();

		$('.carousel-item').click(function(event) {
			
			if (!isScrolling) {
				if ( !$(this).hasClass('is-active')) {

					var index = $(this).index();
					if (index <= 2) prevSlide(index);
					else nextSlide(index-2,false);

				}
			}
		});

		$('.jsCarouselControlIos').click(function(event) {
			if (!isScrolling) {
				if ($(this).hasClass('is-bottom')) nextSlide(1,false) 
					else prevSlide(1);
				pauseVideo();
			}
		});

		$('.carousel-slide-link').click(function(event) {

			var id = $(this).data('id');
			findSlide(id);

		});

		controlVideo();

	})(jQuery);
}

function nextSlide(slide,dataid) {
	(function ($) {

		'use strict';

		$('.jsCarousel').addClass('is-scrolling is-scrolling-up');
		isScrolling = true;

		pauseVideo();

		for (var i = 0; i < slide ; i++) {
			
			$('.jsCarouselScroll').animate({
	        	scrollTop: $('.carousel-item').eq(0).position().top + 'px'
	        }, 450, function() {
	        	
	        	$('.carousel-item.is-active').removeClass('is-active').next().addClass('is-active');
	        	var nextId = $('.carousel-item.is-active').data('id');

	        	$('.jsCarouselScroll').animate({
	        		scrollTop: 0 + 'px'
	        	}, 0, function() {
	        		$('.jsCarousel').removeClass('is-scrolling is-scrolling-up');
	        		isScrolling = false;

	        		mapLink(nextId);

	        		$('.carousel-title-wrapper__inner').removeClass('is-active');
	        		var titleIndex = $('.carousel-item.is-active').data('order');
					$('.carousel-title-wrapper__inner').eq(titleIndex).addClass('is-active');
	        	});

				$('.carousel-item').eq(0).detach().appendTo('.carousel-content');
	        });

		}
		})(jQuery);
}

function prevSlide(slide) {
	(function ($) {

		'use strict';

			$('.jsCarousel').addClass('is-scrolling');
			isScrolling = true;

			pauseVideo();

			$('.carousel-item').last().detach().prependTo('.carousel-content').hide().width(0).show().width('');
			setTimeout(function () {
				$('.carousel-item.is-active').removeClass('is-active').prev().addClass('is-active');
				var nextId = $('.carousel-item.is-active').data('id');
				$('.jsCarousel').removeClass('is-scrolling');
				isScrolling = false;

				mapLink(nextId);

				$('.carousel-title-wrapper__inner').removeClass('is-active');
				$('.carousel-title-wrapper__inner').removeClass('is-active');
        		var titleIndex = $('.carousel-item.is-active').data('order');
				$('.carousel-title-wrapper__inner').eq(titleIndex).addClass('is-active');

				if (slide == 0) prevSlide(1);
			}, 450);

		})(jQuery);
}

function findSlide(id) {
	(function ($) {

		'use strict';
			var mapLinkId = id;
			var slideIndex = $('.carousel-item[data-id="'+mapLinkId+'"]').index();
			if (slideIndex <= 2) prevSlide(slideIndex);
			else nextSlide(slideIndex-2,false);

		})(jQuery);
}

function mapLink(id) {
	(function ($) {

		'use strict';

		$('.carousel-slide-link').removeClass('is-active');
		$('.carousel-slide-link[data-id="'+id+'"]').addClass('is-active');


		})(jQuery);
}

var video;

function controlVideo() {
	(function ($) {

		'use strict';

		$('.carousel-item').click(function(event) {
			
			if ( $(this).hasClass('is-active')) {

				var videoContainer = $(this);
				video = $(this).find('.carousel-video').get(0);
				
				$(this).find('.carousel-video').bind("ended", function() {
					videoContainer.removeClass('is-playing');
					nextSlide(1,false);
				});

				video.addEventListener("webkitendfullscreen", function(){
				    videoContainer.removeClass('is-playing');
				}, false);

				if (video.paused || video.ended) {
					video.play();
					videoContainer.addClass('is-playing');
				}
	   			else {
	   				video.pause();
	   				videoContainer.removeClass('is-playing');
	   			}
			}
			
		});
		
		})(jQuery);
}

function pauseVideo() {
	(function ($) {

		'use strict';

			if ($('.carousel-item').hasClass('is-playing')) {
				video.pause();
				video.currentTime = 0;
				$('.carousel-item').removeClass('is-playing');
			}

		})(jQuery);
}
